import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    card_container: {
        display: 'flex',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${theme.palette.grey[300]}`
    },
    article_container: {
        display: 'flex',
    },
    box_container: {
        display: 'flex',
        flexDirection: 'column'
    },
    stock_checkbox_contaienr: {
        display: 'flex'
    },
    number: {
        fontFamily: 'Alkatra, cursive',
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: 1,
        "& > span:last-child": {
            fontSize: '20px',
        }
    },
    positive: {
        color: theme.palette.success.main
    },
    card_content: {
        flex: '1 0 auto'
    },
    image: {
        height: '100px',
        width: '100px'
    },
    image_container: {
        display: 'flex',
        alignItems: 'center',
        padding: '5px'
    },
    title: {
        fontWeight: 800
    },
    checkbox_container: {
        justifyContent: 'right'
    },
    stock_container: {
        displsy: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        textAlign: 'center',
        maxWidth: '100px',
        marginTop: '10px',
        marginRight: '10px',
    },
    description_container: {
        height: '90px',
        paddingBottom: '20px',
        overflow: 'hidden'
    },
    expand_button_container: {
        textAlign: 'right',
        paddingBottom: '10px'
    },
    prices_container: {
        display: 'flex',
        gap: '8px',
    },
    price_item: {
        margin: '5px 0',
        paddingRight: '15px',
        borderRight: `2px solid ${theme.palette.grey[300]}`,
    },
    price_title: {
        fontSize: '19px',
        fontWeight: 600,
        color: theme.palette.secondary.dark,
    },
    prices_select_container: {
        display: 'flex',
        padding: '10px 0'
    },
    amount_input: {
        marginLeft: '5px'
    },
    amount_input_contaier: {
        width: '100px'
    }
}));

export {useStyles}